import React, { FC } from 'react';
import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { LinkButton } from 'components/atoms';

interface StyleProps {
  reverse?: boolean;
}

export interface FullTextContentProps extends StyleProps {
  className?: string;
  link?: { href: string; text: string };
  title: { text: string; component?: 'h2' };
  text: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapperContent: {
    textAlign: 'center',
    margin: ({ reverse }: StyleProps) => (reverse ? theme.spacing(0, 0, 10) : theme.spacing(10, 0, 0)),
  },
  title: {
    [theme.breakpoints.down(380)]: {
      fontSize: 30,
    },
  },
  text: {
    marginTop: theme.spacing(5),
    color: theme.palette.switchedColors.textGray,
  },
  button: {
    marginTop: theme.spacing(6),
  },
}));

const FullTextContent: FC<FullTextContentProps> = ({ className, link, title, text, reverse }) => {
  const classes = useStyles({ reverse });

  return (
    <Box className={clsx(className)}>
      <Container maxWidth={false} fixed>
        <Grid container justifyContent="center">
          <Grid lg={8} md={10} xs={12} item className={classes.wrapperContent}>
            <Typography variant="h1" component={title.component} className={classes.title}>
              {title.text}
            </Typography>
            <Typography variant="body2" className={classes.text}>
              {text}
            </Typography>
            {link && (
              <LinkButton href={link.href} color="primary" variant="contained" className={classes.button}>
                {link.text}
              </LinkButton>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FullTextContent;
